import { authService } from "../../Services/authServices/requests.ts";

// User Actions
export function SignIn(user){
    localStorage.setItem("user", JSON.stringify(user))
    return{
        type: 'SignIn',
        info: "SignIn",
        payload: user
    }
}

export function LogOut(){
    authService.SignOut();
    let user = JSON.stringify({
        user: '',
        access_token: '',
        isLogged: false
    })
    localStorage.clear()
    localStorage.setItem("user", user);
    return{
        type: 'LogOut',
        info: "LogOut",
    }
}

export function ChangeUserInfo(newUser){
    localStorage.setItem("user", JSON.stringify(newUser))
    return{
        type: 'ChangeUserInfo',
        info: "ChangeUserInfo",
        payload: newUser
    }
}
